import { getStakingEnv } from "./env.js";

/**
 * Public rendered PNG for a token (`image/{tokenId}.png` on metadata host / R2).
 * @param {string} tokenId decimal string
 * @returns {string} absolute URL or "" if invalid
 */
export function getPublicTokenImageUrl(tokenId) {
  const id = String(tokenId ?? "").trim();
  if (!/^\d+$/.test(id)) return "";
  const base = getStakingEnv().metadataOrigin.replace(/\/+$/, "");
  return `${base}/image/${id}.png`;
}
